import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { apiAssessors } from 'helpers/decorators/api'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { ths } from 'constants/layout/wwc-status'
import { Table } from 'components/layout'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Title } from '../../../../components/misc'
import ModalCTA from '../../../../components/layout/Modal/ModalCTA'
import AssessorFileUpload from '../../assessor/AssessorFileUpload/AssessorFileUpload'
import styles from './wwc-status.styl'
import { ASSESSOR_WWC_STATE_TYPES } from '../../../../constants/enums'
import AssessorUpdateWWC from '../../assessor/AssessorUpdateWWC/AssessorUpdateWWC'

@apiAssessors({
  loadWWCStatus: true,
})
@connect(({ auth, api }) => ({
  blobAccessAuthorizationCode: get(auth, 'user.blobAccessAuthorizationCode'),
  blob: api.blob
}))
@injectIntl
class WWCStatus extends Component {
  static propTypes = {
    assessor: PropTypes.any,
    blobAccessAuthorizationCode: PropTypes.string,
    intl: PropTypes.any,
    onUpdateWWCFile: PropTypes.func,
    onUpdateWWCWithoutFile: PropTypes.func,
    blob: PropTypes.object
  }

  state = {
    selectedRow: null,
    addFileDialogOpen: false,
    updateWWCDialogOpen: false
  }

  handleAddFileDialogOpen = wwcFile => {
    this.setState({ selectedRow: wwcFile, addFileDialogOpen: true })
  }

  handleAddFileDialogClose = () => {
    this.setState({ selectedRow: null, addFileDialogOpen: false })
  }

  handleUpdateWWCDialogOpen = wwcFile => {
    this.setState({ selectedRow: wwcFile, updateWWCDialogOpen: true })
  }

  handleUpdateWWCDialogClose = () => {
    this.setState({ selectedRow: null, updateWWCDialogOpen: false })
  }


  handleAddFileDialogSubmit = (fields, authCode, submitData) => {
    const data = { ...fields, assessorId: submitData.assessorId }

    this.props.onUpdateWWCFile(data, authCode, get(this.state.selectedRow, 'id'))
      .then(r => {
        if (r.type.includes('ERROR')) {
          return
        }
        this.handleAddFileDialogClose()
      })
  }

  handleUpdateWWCDialogSubmit = (fields, submitData) => {
    const data = { ...fields, assessorId: submitData.assessorId }

    this.props.onUpdateWWCWithoutFile(data, get(this.state.selectedRow, 'id'))
      .then(r => {
        if (r.type.includes('ERROR')) {
          return
        }
        this.handleUpdateWWCDialogClose()
      })
  }


  displaySubtitle2(label, intlKey) {
    return (<Title h4 className={styles.subtitle2} intlKey={intlKey}>{label}</Title>)
  }

  render() {
    const { assessor, blob, blobAccessAuthorizationCode, intl } = this.props

    const {
      wwc: { list },
    } = assessor.assessors
    const { selectedRow, addFileDialogOpen, updateWWCDialogOpen } = this.state

    const isExempted = wwcFile => get(wwcFile, 'state.value') === ASSESSOR_WWC_STATE_TYPES.exempted.id

    const getCreatedDate = wwcFile => get(wwcFile, 'assessorFile.createdAt') || get(wwcFile, 'modifiedAt')

    const getExpirationDate = wwcFile => get(wwcFile, 'childProtectionExpirationDate')

    const getState = wwcFile => {
      return get(wwcFile, 'state.translationText')
    }

    const getFileUrl = wwcFile => {
      const url = get(wwcFile, 'fileUrl')

      return url ? `${url}&authorizationCode=${blobAccessAuthorizationCode}` : undefined
    }

    return (
      <div className={styles.wwcStatus}>
        <Table.Wrap>
          <tbody>
            {ths.map(({ label, intlKey }, i) => (
              <Table.Cell key={i} head>
                {label ? <FormattedMessage id={intlKey} defaultMessage={label} /> : ''}
              </Table.Cell>
            ))}
            {list && list.map((v, i) => (
              <Table.Row key={i}>
                <Table.Cell>{intl.formatDate(getCreatedDate(v))}</Table.Cell>
                <Table.Cell>{get(v, 'childProtectionExpirationDate') ? intl.formatDate(getExpirationDate(v)) : '---'} </Table.Cell>
                <Table.Cell>
                  {get(v, 'assessorFile.logicalFilename') && <a href={getFileUrl(v)} target="_blank" rel="noreferrer" className={styles.link}>
                    {get(v, 'assessorFile.logicalFilename')}
                  </a> || '---'}

                </Table.Cell>
                <Table.Cell>{getState(v)}</Table.Cell>
                <Table.Cell>{get(v, 'assessor.organization.name')}</Table.Cell>
                <Table.Cell>
                  {!isExempted(v) && (
                    <span
                      className="link"
                      onClick={() => this.handleAddFileDialogOpen(v)}
                    >
                      <FormattedMessage id="button.upload_wwc_file" defaultMessage="Upload WWC File" />
                    </span>)}
                  <br />
                  {!isExempted(v) && (
                    <span
                      className="link"
                      onClick={() => this.handleUpdateWWCDialogOpen(v)}
                    >
                      <FormattedMessage id="button.update_wwc" defaultMessage="Update WWC" />
                    </span>)}

                </Table.Cell>
              </Table.Row>
            ))}
          </tbody>
        </Table.Wrap>
        {addFileDialogOpen && <ModalCTA title="File upload" titleKey="moduleTitle.file_upload" onClose={this.handleAddFileDialogClose}>
          <AssessorFileUpload
            onSubmit={this.handleAddFileDialogSubmit}
            authCode={blobAccessAuthorizationCode}
            loading={get(blob, 'loading')}
            assessorId={get(selectedRow, 'assessor.id')}
            withWWCNumber
          />
        </ModalCTA>}
        {updateWWCDialogOpen && <ModalCTA title="Update WWC" titleKey="moduleTitle.update_wwc" onClose={this.handleUpdateWWCDialogClose}>
          <AssessorUpdateWWC
            onSubmit={this.handleUpdateWWCDialogSubmit}
            loading={get(blob, 'loading')}
            assessorId={get(selectedRow, 'assessor.id')}
            withWWCNumber
          />
        </ModalCTA>}
        {this.displaySubtitle2('You can upload your new WWC / PCN certificate here.', 'label.before_wwc_expires')}
        {this.displaySubtitle2('Please unsure you upload this certificate before your old one expires to ensure continued use of the system.', 'label.before_wwc_expires_2')}
      </div>
    )
  }
}

export default WWCStatus
